import { render } from "./Header.vue?vue&type=template&id=26093726"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "../styles/header.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "C:\\Users\\BARNABAS\\Documents\\dev projects\\pet-mobi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__